class MapTeaser {
    constructor(element) {
        this.container = element;
        this.trigger = this.container.querySelector('.js-map-teaser-trigger');
        this.iframe = this.container.querySelector('.js-map-teaser-iframe');
        this.iframeSrc = this.container.dataset.iframe;

        this.initEvent();
    }

    initEvent() {
        this.trigger.addEventListener('click', (event) => {
            event.preventDefault();
            this.showContent();
        });
    }

    showContent() {
        this.container.classList.add('iframe-loaded');
        this.iframe.src = this.iframeSrc;
        this.iframe.style.display = 'block';
    }
}

const mapTeaser = {
    init() {
        const elements = document.querySelectorAll('.js-map-teaser');

        if (!elements) return;

        elements.forEach((element) => {
            this.mapTeaser = new MapTeaser(element);
        });
    },
};

export default mapTeaser;
